import React from 'react'
import "./CustomLoader.css";

const CustomLoader = () => {
  return (
    <div class="loader">
  <span class="element"></span>
  <span class="element "></span>
  <span class="element"></span>
</div>
  )
}

export default CustomLoader
